
import { createSlice } from '@reduxjs/toolkit';
import { fetcherGet, fetcherPost, fetcherPut } from "../utils/fetcher";
import { setLoader } from './commonSlice';
import { APIS, createUserEndpoints, role, isEmpty } from '../utils/constants';
import { checkNextPage } from '../utils/logger';
// import en from "../../src/nls/en.json"

const initialState = {
    userDetails: [],
    universityList: [],
    userDataBeforeCreatePwd: [],
    currentUser: [],
    isLoaded: [],
    userSignOut: [],
    createUserStatus: null,
    newUserCreated: null,
    userTypePreLogin: null,
    userType: null,
    rolesOfSchoolAdmin: [],
    districtList: [],
    packageSessionIds: []
}

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUserTypePreLogin: (state, action) => {
            state.userTypePreLogin = action.payload;
        },
        setUserType: (state, action) => {
            state.userType = action.payload
        },
        setUniversity: (state, action) => {
            state.universityList = action.payload
        },
        setUserRegDetails: (state, action) => {
            state.userDetails = action.payload;
        },
        setUserDataBeforeCreatePwd: (state, action) => {
            state.userDataBeforeCreatePwd = action.payload;
        },
        setCurrentUser: (state, action) => {
            state.currentUser = action.payload;
        },
        setIsLoaded: (state, action) => {
            state.isLoaded = action.payload;
        },
        setSignOut: (state, action) => {
            state.userSignOut = action.payload;
        },
        setCreateUserStatus: (state, action) => {
            state.createUserStatus = action.payload;
        },
        setNewUserCreated: (state, action) => {
            state.newUserCreated = action.payload;
        },
        setRolesOfSchoolAdmin: (state, action) => {
            state.rolesOfSchoolAdmin = action.payload;
        },
        setDistrictList: (state, action) => {
            state.districtList = action.payload;
        },
        setPackageSessionIds: (state, action) => {
            state.packageSessionIds = action.payload;
        },
    }
});

export function getEntities() {
    return (dispatch) => {
        // Axios to hit BE API
        dispatch(setUserRegDetails({ userName: "Jhon" }));
    };
}

export function createUser(payload, callback) {
    return (dispatch) => {
        dispatch(setLoader(true));
        const { param, email } = payload;
        let URL = APIS?.CREATE_USER;
        if (param === role.student) {
            URL = URL + createUserEndpoints.B2CStudent;
        } else if (param === role.mentor) {
            URL = URL + createUserEndpoints.addMentor;
        }
        fetcherPost(URL, { email: email })
            .then((res) => {
                dispatch(setCreateUserStatus(true));
                dispatch(setLoader(false));
                if(callback){
                    callback(res);
                }
            })
            .catch((err) => {
                dispatch(setCreateUserStatus(false));
                if(callback){
                    callback(err);
                }
                dispatch(setLoader(false));
            });
    };
}

export function existingUser() {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(APIS.IS_USER_EXISTS)
            .then((res) => {
                if (res?.data?.isUserExist) {
                    dispatch(setCreateUserStatus(true));
                    dispatch(setLoader(false));
                }
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function getUniversityList(page = 1, prev = [], searchQuery) {
    return (dispatch) => {
        let url = `${APIS.GET_UNIVERSITY_LIST}${page}`;
        if (searchQuery?.length) {
            url = url + `&search=${searchQuery}`
        }
        fetcherGet(url)
            .then((response) => {
                const universities = !isEmpty(response?.data) ? response?.data : {};
                const resp = checkNextPage(universities?.pagination);
                universities.pagination = resp;
                universities.result = [...prev, ...universities.result];
                dispatch(setUniversity(universities));
            })
            .catch((err) => {
                console.error(err);
            });
    };
}

//for Add result form's university list
export function getUniversity(page = 1, prev = [], searchQuery, callback) {
    return () => {
        let url = `${APIS.GET_UNIVERSITY_LIST}${page}`;
        if (searchQuery?.length) {
            url = url + `&search=${searchQuery}`
        }
        fetcherGet(url)
            .then((response) => {
                const universities = !isEmpty(response?.data) ? response?.data : {};
                const resp = checkNextPage(universities?.pagination);
                universities.pagination = resp;
                universities.result = [...prev, ...universities.result];
                {callback && callback(universities)}
            })
            .catch((err) => {
                console.error(err);
            });
    };
}

export function getSchoolAdminRoles() {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(APIS.GET_SCHOOL_ADMIN_ROLE)
            .then((response) => {
                const roles = !isEmpty(response?.data) ? response?.data : {};
                dispatch(setRolesOfSchoolAdmin(roles));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function getDistrictList(page = 1, prev = [], searchQuery) {
    return (dispatch) => {
        dispatch(setLoader(true));
        let url = `${APIS.GET_DISTRICTS}?page=${page}`;
        if (searchQuery?.length) {
            url = url + `&search=${searchQuery}`
        }
        fetcherGet(url)
            .then((response) => {
                const districts = !isEmpty(response?.data) ? response?.data : {};
                const res = checkNextPage(districts.pagination)
                districts.pagination = res;
                districts.result = [...prev, ...districts.result];
                dispatch(setDistrictList(districts));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function putSchoolAdmin(payload, callBack) {
    return (dispatch) => {
        dispatch(setLoader(true));
        const { user_id, ...rest } = payload;
        fetcherPut(APIS?.POST_SCHOOL_ADMIN + user_id, rest)
            .then(() => {
                dispatch(setLoader(false));
                callBack()
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function changePassword(payload, callBack) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPut(APIS?.PUT_CHANGE_PASSWORD, payload)
            .then((res) => {
                dispatch(setLoader(false));
                callBack(res);
            })
            .catch((err) => {
                callBack(err);
                dispatch(setLoader(false));
            });
    };
}
//FP
export function forgotPassword(payload, callBack) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPut(APIS?.FORGOT_PASSWORD, payload)
            .then((res) => {
                dispatch(setLoader(false));
                callBack(res);
            })
            .catch((err) => {
                callBack(err);
                dispatch(setLoader(false));
            });
    };
}
export function ResendTempPass(payload, callBack) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.RESEND_TEMP_PASS, payload)
            .then((res) => {
                dispatch(setLoader(false));
                callBack(res);
            })
            .catch((err) => {
                callBack(err);
                dispatch(setLoader(false));
            });
    };
}
//RP
export function resetPassword(payload, callBack) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPut(APIS?.RESET_PASSWORD, payload)
            .then((res) => {
                dispatch(setLoader(false));
                callBack(res);
            })
            .catch((err) => {
                callBack(err);
                dispatch(setLoader(false));
            });
    };
}
//ER
export function getEmail(token, callBack) {
    return (dispatch) => {
        dispatch(setLoader(true));
        let url = `${APIS.GET_EMAIL_FORGOT}${token}`;
        fetcherGet(url)
            .then((res) => {
                dispatch(setLoader(false));
                callBack(res);
            })
            .catch((err) => {
                callBack(err);
                dispatch(setLoader(false));
            });
    };
}
//function to check if user has setted his custom password or not
export function customPassCheck(email, callback){
    return (dispatch) => {
        dispatch(setLoader(true));
        let url = `${APIS.CUSTOM_PASS_CHECK}${email}`;
        fetcherGet(url)
            .then((res) => {
                dispatch(setLoader(false));
                if(callback){
                    callback(res);
                }
            })
            .catch((err) => {
                callback(err);
                dispatch(setLoader(false));
            });
    };
}

//To set user status to Active once the user sets his Custom Password
export function setRegisterationStatus(){
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPut(APIS.SET_REGISTERATION_STATUS)
            .then(() => {
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function docEditAvailability(payload) {
    return (dispatch) => {
        fetcherPut(APIS?.DOC_EDIT_AVAILABILITY, payload)
            .then(() => {
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function AIchatBot(payload, callBack) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.AI_CHAT_BOT, payload)
            .then((res) => {
                dispatch(setLoader(false));
                callBack(res);
            })
            .catch((err) => {
                callBack(err);
                dispatch(setLoader(false));
            });
    };
}

export function getOtherSchool(callBack) {
    return (dispatch) => {
        dispatch(setLoader(true));
        let url = `${APIS.OTHER_SCHOOL}`;
        fetcherGet(url)
            .then((res) => {
                dispatch(setLoader(false));
                callBack(res?.data);
            })
            .catch((err) => {
                callBack(err);
                dispatch(setLoader(false));
            });
    };
}

export function getPackageSessionIds(param) {
    // no-unused-vars
    const {success_url, cancel_url} = param;
    return (dispatch) => {
        dispatch(setLoader(true));
        let url = `${APIS.GET_PACKAGE_SESSIONS}?success_url=${success_url}&cancel_url=${cancel_url}`;
        fetcherGet(url)
            .then((res) => {
                dispatch(setPackageSessionIds(res?.data));
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export const { setUserTypePreLogin, setUserRegDetails, setUserDataBeforeCreatePwd, setCurrentUser, setUniversity,
    setIsLoaded, setSignOut, setCreateUserStatus, setNewUserCreated, setUserType, setRolesOfSchoolAdmin, setDistrictList, setPackageSessionIds } = userSlice.actions;
export default userSlice.reducer;